import { createContext } from 'react';
import { ApolloQueryResult } from '@apollo/client';

import { GetAppConfigQuery } from '@ocx/graphql';

import { MembershipConfigOverrides, RuntimeConfig } from './app-config.types';

export type IConfigurationContextValue = {
  error: unknown;
  loaded: boolean;
  config: RuntimeConfig | null;
  setMembershipOverrides(overrides: MembershipConfigOverrides | null): void;
  refetch(): Promise<ApolloQueryResult<GetAppConfigQuery>>;
};

export const ConfigurationContext = createContext<IConfigurationContextValue | null>(null);
